import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { Switch, Breadcrumbs, FormControlLabel, TextField } from '@mui/material';
import { GetSchema, AuthCode } from '../../../js/Base/ValidationSchema';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { InputField } from '../../../components/Common/FormikField/InputField';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import { GreenSwitch } from '../../../components/Common/GreenSwitch';
import TimezoneSelect from "react-timezone-select";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { store } from "../../../store/store"
import { useSelector, useDispatch } from "react-redux";
import { fetchCompanyLicense } from '../../../store/slices/licenseSlice';
import { cloudNativeEnabledSelector, crowdstrikeEnabledSelector } from "../../../store/selectors/licenseSelectors";
import { insertCompanyLicense } from '../../../api/keyApi';

export default function SystemAuthCard({ company }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCompanyLicense());
  }, []);
  
  const license = useSelector((state) => state.license.data);
  const formSchema = GetSchema({
    license: AuthCode(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const companyUuid = localStorage.getItem("company_uuid");
      const payload = {
        company_uuid: companyUuid,
        license_key: values.license,
      };
      const data = await insertCompanyLicense(payload);
      if (data.success) {
        toastAlert.autoClose(true).showSuccess("授權成功");
      } else {
        toastAlert.autoClose(true).showError("授權失敗，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("授權失敗，請稍後再試");
    } finally {
      await dispatch(fetchCompanyLicense()).unwrap();
      setSubmitting(false);
    }
  };

  return (
    <Card className="CompanyManagement" style={{ marginBottom: '20px'}}>
      <Card.Header style={{ backgroundColor: 'transparent' }}>
        <strong style={{ fontSize:'16px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }}>系統授權</strong>
      </Card.Header>
      <Formik
        initialValues={{ license: license?.license_key || "" }}
        enableReinitialize
        validationSchema={formSchema}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
          <Form>
            <Card.Body style={{ paddingTop: '5px' }}>
              <Row>
              <Col md="12">
                {license?.license_key ? (
                  <div
                    style={{
                      padding: '12px',
                      color: '#28a745',
                      fontWeight: 'bold',
                    }}
                  >
                    授權成功
                  </div>
                ) : (
                  <InputFormFiled
                    title="License Key"
                    className="input-field custom-select"
                    name="license"
                    type="textarea"
                    maxLength="600"
                    rows="5"
                    invalid={errors.license && touched.license}
                  />
                )}
              </Col>
              </Row>
            </Card.Body>
            <Card.Footer
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '50px',
                paddingBottom: '28px',
                paddingRight: '26px',
                paddingTop: '20px',
                backgroundColor: 'transparent',
                height: '85px',
              }}
            >
              <Button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-custom"
              >
                儲存
              </Button>
            </Card.Footer>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
